export default __webpack_public_path__ + "7b0964dbdc4370bd1bffa990fa74a0f2.svg";